module.exports = __webpack_public_path__ + "images/district_back.1791972770245.png";